export function normalizeTicketTimestampInput(
  input: Date | string | number,
): Date {
  if (input instanceof Date) {
    return input;
  }
  if (typeof input === 'number') {
    return new Date(input);
  }

  const raw = input.trim();
  const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(raw);
  const normalized = hasTimezone ? raw : `${raw.replace(' ', 'T')}Z`;
  return new Date(normalized);
}

/**
 * Fixed calendar format for ticket "document" timestamps.
 * Displays stored wall-clock components without timezone conversion.
 */
export function formatTicketDocumentDateTime(
  input: Date | string | number | null | undefined,
): string {
  if (input == null || input === '') return '';
  const d = normalizeTicketTimestampInput(input);
  if (Number.isNaN(d.getTime())) return '';

  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const year = String(d.getUTCFullYear());
  const hour = String(d.getUTCHours()).padStart(2, '0');
  const minute = String(d.getUTCMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hour}:${minute}`;
}
